import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";
import CompanyCardContent from "./CompanyActivityCardContent";

interface Props {
  activity: server.dto.CompanyActivity
}

const CompanyActivityRowCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
    <CompanyCardContent activity={activity} />
  </ActivityCard>;
};

export default CompanyActivityRowCard;